export function HoverLabel(context = document) {
    let inputEls = context.querySelectorAll('.u-form-label')
    let inputs = Array.from(inputEls).map((el) => {
        return {
            el,
            input: el.querySelector('input, textarea, select')
        }
    })

    setupInitialState(inputs)
    addEventListeners(inputs)
}

function setupInitialState(inputs) {
    inputs.forEach(({ el, input }) => {
        if (el.dataset.hoverSetup) {
            return
        }

        if (!input.value) {
            el.removeAttribute('data-active')
        } else if (!el.dataset.active) {
            el.dataset.active = true
        }

        el.dataset.hoverSetup = true
    })
}

function addEventListeners(inputs) {
    inputs.forEach(({ input }) => {
        if (input.tagName === 'SELECT') {
            input.addEventListener('showDropdown', handleFocus)
            input.addEventListener('hideDropdown', handleBlur)
        } else {
            input.addEventListener('focus', handleFocus)
            input.addEventListener('blur', handleBlur)
        }
    })
}

function handleFocus(evt) {
    let target = evt.target.closest('.u-form-label')
    if (!target) return
    target.dataset.active = true
}

function handleBlur(evt) {
    let target = evt.target.closest('.u-form-label')
    if (!target) return
    if (!evt.target.value) {
        target.removeAttribute('data-active')
    }
}
